import { render, staticRenderFns } from "./AddExternalLink.vue?vue&type=template&id=8d3c7fee&"
import script from "./AddExternalLink.vue?vue&type=script&lang=js&"
export * from "./AddExternalLink.vue?vue&type=script&lang=js&"
import style0 from "./AddExternalLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports